import { useSelector } from '../react';
import {
  SPLIT_VIEW_FEATURE,
  UNIFIED_SPLIT_VIEW_TEST_1,
  selectFeatureFlag,
} from './featureFlags';

export const useIsSplitViewEnabled = () =>
  useSelector(selectFeatureFlag(SPLIT_VIEW_FEATURE));

export const useIsUnifiedSrpSplitViewExperiment1Enabled = () => {
  const isSplitViewEnabled = useIsSplitViewEnabled();
  const isExperimentEnabled = useSelector(
    selectFeatureFlag(UNIFIED_SPLIT_VIEW_TEST_1),
  );
  return isSplitViewEnabled && isExperimentEnabled;
};
